// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__ShvBm","header":"modal_header__aQeuN","title":"modal_title__lcx9Z","close":"modal_close__usFsi","closeWithoutTitle":"modal_closeWithoutTitle__KSbJl"};